import { tryCatch } from "@/lib/try-catch";
import { initializeApp } from "@firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  type Messaging,
  type MessagePayload,
} from "@firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB8ZrsZtzbD1Gytlsghwy7U9613S1nRoK8",
  authDomain: "progressmade-e8245.firebaseapp.com",
  projectId: "progressmade-e8245",
  storageBucket: "progressmade-e8245.firebasestorage.app",
  messagingSenderId: "825598035358",
  appId: "1:825598035358:web:15822fb090567962bac28f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Check if the browser supports Firebase messaging
const isFirebaseMessagingSupported = () => {
  if (typeof window === "undefined") return false;

  // Check for required APIs
  const hasServiceWorker = "serviceWorker" in navigator;
  const hasNotification = "Notification" in window;
  const hasPushManager = "PushManager" in window;

  // Check if we're in a secure context (required for service workers)
  const isSecureContext = window.isSecureContext || location.protocol === "https:";

  return hasServiceWorker && hasNotification && hasPushManager && isSecureContext;
};

// Only initialize messaging on the client side with proper browser support
let messaging: Messaging | null = null;
if (typeof window !== "undefined" && isFirebaseMessagingSupported()) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn("Firebase messaging initialization failed:", error);
    messaging = null;
  }
} else if (typeof window !== "undefined") {
  console.warn("Firebase messaging is not supported in this browser environment");
}

export const requestNotificationPermissionWeb = async () => {
  if (!messaging) {
    throw new Error("Firebase messaging is not supported in this environment");
  }

  const { error, data } = await tryCatch(Notification.requestPermission());

  if (error) {
    console.error("Error requesting notification permission:", error);
    throw error;
  }

  if (data === "granted") {
    const fcmToken = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    });
    return fcmToken;
  }
};

export const getExistingFCMToken = async (): Promise<string | null> => {
  if (!messaging) {
    console.warn("Firebase messaging is not supported in this environment");
    return null;
  }

  const { error, data: fcmToken } = await tryCatch(
    getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    }),
  );

  if (error) {
    console.error("Error getting existing FCM token:", error);
    return null;
  }

  return fcmToken;
};

export const onMessageListener = () =>
  new Promise<MessagePayload | null>((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }

    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export { messaging };
export type { MessagePayload };
